import React, { useState, useEffect } from 'react'
import DateComponent from '../../Subcomponents/DateComponent'
import TimeComponent from '../../Subcomponents/TimeComponent'
import cssClasses from './AddEvent.module.css'

//ICONS AND IMAGES
import galleryImg from '../../Assets/Images/Common/gallery.svg'
import Button from '../../Subcomponents/Button'
import { useNavigate } from 'react-router-dom'
import CustomInput from '../../Subcomponents/CustomInput'
import { addEvent, getEvent, updateEvent, uploadEventBannerImg } from '../../Services/Event'
import { errorTost, successTost } from '../../Services/Toast'
import { dismissLoader, presentLoader } from '../../Services/loader'
import { Box } from '@mui/material'

export default function AddEvent() {
    const navigate = useNavigate()
    const [event, setEvent] = useState({})
    const [helperText, setHelperText] = useState({ title: '', startDateTime: '', endDateTime: '' })
    const [uploadedFile, setUploadedFile] = useState(null)

    useEffect(() => {
        const event = localStorage.getItem('event')
        if (event === '') {
            setEvent({ title: '', description: '', startDateTime: '', endDateTime: '', bannerImgUrl: '' })
        } else {
            presentLoader()
            getEvent(event).then((resp) => {
                resp[0].tokensRepeatedEventId = resp[0].tokensRepeatedEventId ? resp[0].tokensRepeatedEventId.tokensRepeatedEventId : null;
                setEvent(resp[0])
                dismissLoader()
            })
        }
    }, [])


    function cancel() {
        navigate('/home/Event')
    }

    function validateEvent() {
        let validateFlag = 0
        if (event.title === '') {
            setHelperText((pre) => { pre.title = 'Please enter event title'; return { ...pre } })
            validateFlag = 1
        }
        if (event.startDateTime === '') {
            setHelperText((pre) => { pre.startDateTime = 'Please enter event start date'; return { ...pre } })
            validateFlag = 1
        }
        if (event.endDateTime === '') {
            validateFlag = 1
            setHelperText((pre) => { pre.endDateTime = 'Please enter event end date'; return { ...pre } })
        }
        // if (event.startTime === '') {
        //     validateFlag = 1
        //     setHelperText((pre) => { pre.startTime = 'Please enter event start time'; return { ...pre } })
        // }
        // if (event.endDate === '') {
        //     validateFlag = 1
        //     setHelperText((pre) => { pre.endTime = 'Please enter event end time'; return { ...pre } })
        // }
        return validateFlag
    }

    function save() {
        const validateflag = validateEvent()
        if (validateflag === 0) {
            presentLoader()
            if (!event.eventId) {
                event.created_at = new Date()
                addEvent(event).then((resp) => {
                    if (uploadedFile) {
                        convertImageFileToWebpFile(uploadedFile).then((file) => {
                            uploadEventBannerImg(resp[0].eventId, file).then((res) => {
                                updateEvent(resp[0].eventId, { bannerImgUrl: `eventbannerimages/${resp[0].eventId}.webp` }).then((r) => {
                                    dismissLoader()
                                    navigate('/home/Event')
                                    successTost("Event added successfully")
                                })
                            })
                        })
                    } else {
                        console.log(resp)
                        dismissLoader()
                        navigate('/home/Event')
                        successTost("Event added successfully")
                    }
                }).catch((err) => {
                    if (err.message === `duplicate key value violates unique constraint "Events_title_key"`) {
                        dismissLoader()
                        setHelperText((pre) => { pre.title = 'Event with same title already exists'; return { ...pre } })
                    } else {
                        dismissLoader()
                        errorTost("Something went wrong please try again later")
                    }
                })
            } else {
                console.log('event: ', event);
                updateEvent(event.eventId, event).then((resp) => {
                    if (uploadedFile) {
                        convertImageFileToWebpFile(uploadedFile).then((file) => {
                            uploadEventBannerImg(event.eventId, file).then((res) => {
                                updateEvent(resp[0].eventId, { bannerImgUrl: `eventbannerimages/${resp[0].eventId}.webp` }).then((r) => {
                                    dismissLoader()
                                    navigate('/home/Event')
                                    successTost("Event updated successfully")
                                })
                            })
                        })
                    } else {
                        dismissLoader()
                        navigate('/home/Event')
                        successTost("Event updated successfully")
                    }
                }).catch((err) => {
                    if (err.message === `duplicate key value violates unique constraint "Events_title_key"`) {
                        dismissLoader()
                        setHelperText((pre) => { pre.title = 'Event with same title already exists'; return { ...pre } })
                    } else {
                        dismissLoader()
                        errorTost("Something went wrong please try again later")
                    }
                })
            }
        }
    }

    function convertImageFileToWebpFile(file) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
                canvas.getContext("2d").drawImage(image, 0, 0);
                canvas.toBlob((blob) => {
                    let myFile = new File([blob], "my-new-group-image.webp", {
                        type: blob.type,
                    });
                    resolve(myFile);
                }, "image/webp");
            };
            image.crossOrigin = "anonymous";
            image.src = URL.createObjectURL(file);
        });
    }

    useEffect(() => {
        if (uploadedFile) {
            document.getElementById('eventBannerImg').src = URL.createObjectURL(uploadedFile)
        }
    }, [uploadedFile])

    return (
        <div className='pageWrapper'>
            <div className={cssClasses.mainContainer}>
                <div className={cssClasses.mainWrapper}>
                    <div className={cssClasses.leftWrapper}>
                        <div className={cssClasses.section}>
                            <div className={cssClasses.label}>
                                <p>Event Title <span style={{ color: "red" }}>*</span></p>
                            </div>
                            <div className={cssClasses.input}>
                                <CustomInput helperText={helperText.title} value={event.title} placeholder={'Enter event title'} handleChange={(e) => { setEvent((pre) => { pre.title = e; return { ...pre } }); setHelperText((pre) => { if (event.title !== '') { pre.title = '' } else { pre.title = 'Please enter event title' }; return { ...pre } }) }} />
                            </div>
                        </div>
                        <div className={cssClasses.section}>
                            <div className={cssClasses.label}>
                                <p>Event Description</p>
                            </div>
                            <div className={cssClasses.inputTextarea}>
                                <textarea value={event.description} className={cssClasses.textarea} placeholder='Enter Description...' onChange={(e) => { setEvent((pre) => { pre.description = e.target.value; return { ...pre } }) }} name="" id="" cols="30" rows="10"></textarea>
                            </div>
                        </div>
                        <div className={cssClasses.section}>
                            <div className={cssClasses.label}>
                                <p>Event Allotment Duration:</p>
                            </div>
                            <div style={{ marginTop: "2.5rem" }}>
                                <div className={cssClasses.inputWrapper}>
                                    <div className={cssClasses.input}>
                                        <Box width={'30rem'}>
                                            <DateComponent 
                                            helperText={helperText.startDateTime} 
                                            label={`Start Date Time`} 
                                            maxDate={event.endDateTime} 
                                            isMandatory={true} 
                                            onChangeDate={(e) => { 
                                                setEvent((pre) => { pre.startDateTime = new Date(e).getTime(); return { ...pre } }); setHelperText((pre) => { if (event.startDateTime !== '') { pre.startDateTime = '' } else { pre.startDateTime = 'Please enter event start date' }; return { ...pre } }) }} value={event.startDateTime} />
                                        </Box>

                                    </div>
                                    <div className={cssClasses.input}>
                                        <Box width={'30rem'}>
                                            <DateComponent disabled={event.startDateTime === ''} isMandatory={true} minDate={event.startDateTime} helperText={helperText.endDateTime} label={'End Date Time'} onChangeDate={(e) => { setEvent((pre) => { pre.endDateTime = new Date(e).getTime(); return { ...pre } }); setHelperText((pre) => { if (event.endDateTime !== '') { pre.endDateTime = '' } else { pre.endDateTime = 'Please enter event end date' }; return { ...pre } }) }} value={event.endDateTime} />
                                        </Box>

                                    </div>
                                </div>
                                {/* <div className={cssClasses.inputWrapper}>
                                    <div className={cssClasses.input}>
                                        <TimeComponent helperText={helperText.startTime} label={'Start Time'} onChangeTime={(e) => { setEvent((pre) => { pre.startTime = e; return { ...pre } }); setHelperText((pre) => { if (event.startTime !== '') { pre.startTime = '' } else { pre.startTime = 'Please enter event start time' }; return { ...pre } }) }} value={event.startTime} />
                                    </div>
                                    <div className={cssClasses.input}>
                                        <TimeComponent helperText={helperText.endTime} label={'End Time'} onChangeTime={(e) => { setEvent((pre) => { pre.endTime = e; return { ...pre } }); setHelperText((pre) => { if (event.endTime !== '') { pre.endTime = '' } else { pre.endTime = 'Please enter event end time' }; return { ...pre } }) }} value={event.endTime} />
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <div className={cssClasses.rightWrapper}>
                        <div className={cssClasses.uploadWrapper}>
                            <div className={cssClasses.label}>
                                <p>Event Banner</p>
                            </div>
                            <div className={cssClasses.upload} onClick={() => { document.getElementById('imgupload').click() }}>
                                {event.bannerImgUrl || uploadedFile ?
                                    <div className={cssClasses.uploadInputImg}>
                                        <Box height={'100%'} width={'fit-Content'}>
                                            <img className={cssClasses.uploadedImg} id='eventBannerImg' src={event.bannerImgUrl ? process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + event.bannerImgUrl + `?${Date.now()}` : ''} alt="" />
                                        </Box>

                                        <input hidden type="file" accept='image/*' id='imgupload' name="" onChange={(e) => { setUploadedFile(e.target.files[0]) }} />
                                        <div className={cssClasses.reupload}>
                                            <div className={cssClasses.uploadImg1}>
                                                <img src={galleryImg} alt="" />
                                            </div>
                                            <div className={cssClasses.uplaodLabel1}>
                                                <p>Upload here</p>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className={cssClasses.uploadInput}>
                                        <div className={cssClasses.uploadImg}>
                                            <img src={galleryImg} alt="" />
                                        </div>
                                        <div className={cssClasses.uplaodLabel}>
                                            <p>Upload here</p>
                                        </div>
                                        <input hidden type="file" accept='image/*' id='imgupload' name="" onChange={(e) => { setUploadedFile(e.target.files[0]) }} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className={cssClasses.footer}>
                    <div>
                        <Button btnName={"Cancel"} clicked={cancel} style={{ color: "#98A2B3", boxShadow: "none", border: "none", backgroundColor: "#FFFFFF" }} />
                    </div>
                    <div>
                        <Button btnName={"Save"} clicked={save} style={{ color: "#FFFFFF", backgroundColor: "#1570EF", borderRadius: "0.4rem" }} />
                    </div>
                </div>
            </div>
        </div>
    )
}
